import { useEffect, useState } from "react";

/**
 * Tracks whether the viewport is at or below a mobile breakpoint.
 * Defaults to 768px to match the app's existing CSS media queries.
 */
export function useIsMobile(maxWidth = 768): boolean {
    const query = `(max-width: ${maxWidth}px)`;
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== "undefined" && window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setIsMobile(mql.matches);
        onChange();
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return isMobile;
}
